import { DoctorUser, ActionTypes, State, Action } from './types';

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case ActionTypes.SET_BLOCKED_VISIBLE:
      return { ...state, isBlockedVisible: action.data as boolean };
    case ActionTypes.SET_REDIRECT_PATH:
      return { ...state, redirectPath: action.data as string };
    case ActionTypes.SET_TMP_TOKEN:
      return { ...state, tmpToken: action.data as string };
    case ActionTypes.SET_USER:
      return { ...state, user: action.data as DoctorUser, isLoading: false };
    case ActionTypes.SET_LOADING:
      return { ...state, isLoading: action.data as boolean };
    default:
      return state;
  }
};

export default reducer;
